import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'activeRoute',
    standalone: true
})
export class ActiveRoutePipe implements PipeTransform {

	transform(url: string = '', segment: string = ''): boolean {
		return segment ? url.includes(segment) : false;
	}
}
